window.app = window.app || {};

window.app.productInBundle = {
  el: {},

  init: function() {
    const _this = this;
    _this.el = {
      list: document.querySelector('.mt-whats-in-bundle__list'),
      listCarousel: document.querySelector('.mt-whats-in-bundle__list .swiper'),
      items: document.querySelectorAll('.mt-whats-in-bundle__item')
    };
    if (!_this.el.list || _this.el.items.length == 0) return;

    _this.slider = new Swiper(_this.el.listCarousel, {
      slidesPerView: 1,
      spaceBetween: 30,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 50,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
        },
        1100: {
          slidesPerView: 5,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
        }
      }
    });

    _this.el.items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        _this.el.list.classList.add('mt-whats-in-bundle__list--highlight');
      });
      item.addEventListener('mouseleave', () => {
        _this.el.list.classList.remove('mt-whats-in-bundle__list--highlight');
      });
    });
  }
}
window.app.productInBundle.init();